import { Form, Row } from 'antd';
import React, { useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { dokumentDodatekBankUcetPut } from 'services/dokumenty/dodatek';
import { ISmlouvniStrany, dokumentSmlouvniStranyGet } from 'services/dokumenty/smlouva';

import { cisloUctuValidation, kodBankyValidation, predcisliValidation } from 'utils/validations/bankUcetValidation';
import ibanValidation from 'utils/validations/ibanValidation';

interface IBankUcet {
    nextStep: () => void;
    prevStep: () => void;
    zadostID: number;
    signingDisabled: boolean;
}

const BankUcet: React.FC<IBankUcet> = ({ nextStep, prevStep, zadostID, signingDisabled }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<ISmlouvniStrany>();

    useEffect(() => {
        setLoading(true);
        dokumentSmlouvniStranyGet(zadostID)
            .then(resp => setData(resp))
            .finally(() => setLoading(false));
    }, [zadostID]);

    return (
        <LoadingWrapper loading={loading}>
            {data && (
                <FormWrapper
                    outForm={form}
                    onFinish={values => {
                        setLoading(true);
                        dokumentDodatekBankUcetPut(zadostID, {
                            ...(values.predcisli && {
                                predcisli: values.predcisli
                            }),
                            cislouctu: values.cislouctu,
                            banka: values.banka,
                            ...(values.iban && {
                                iban: values.iban.split(' ').join('')
                            })
                        })
                            .then(() => nextStep())
                            .finally(() => setLoading(false));
                    }}
                >
                    <Title text="BANK_UCET_EMITENT" level={5} />
                    <InputComponent
                        label="PREDCISLI_UCTU"
                        name="predcisli"
                        initialValue={data.spolecnost?.predcisli ? data.spolecnost?.predcisli : undefined}
                        notRequired={true}
                        maxLength={6}
                        rules={predcisliValidation()}
                        disabled={signingDisabled}
                    />
                    <InputComponent
                        label="CISLO_UCTU"
                        name="cislouctu"
                        initialValue={data.spolecnost?.cislouctu ? data.spolecnost?.cislouctu : undefined}
                        maxLength={10}
                        rules={cisloUctuValidation()}
                        disabled={signingDisabled}
                    />
                    <InputComponent
                        label="CISLO_BANKY"
                        name="banka"
                        initialValue={data.spolecnost?.banka ? data.spolecnost?.banka : undefined}
                        maxLength={4}
                        rules={kodBankyValidation()}
                        disabled={signingDisabled}
                    />
                    <InputComponent
                        label="IBAN"
                        infoTooltipText="ISIN_IDENTIFIKACE_VLASTNIK_HELP"
                        name="iban"
                        maxLength={34}
                        rules={ibanValidation()}
                        notRequired={true}
                        initialValue={data.spolecnost?.iban ? data.spolecnost?.iban : undefined}
                        disabled={signingDisabled}
                    />
                    <Row className="button-row">
                        <ButtonComponent buttontext="ZPET" onClick={() => prevStep()} id="isinZpetBtn" type="default" />
                        <ButtonComponent buttontext="POKRACOVAT" htmlType="submit" id="isinPokracovatBtn" />
                    </Row>
                </FormWrapper>
            )}
        </LoadingWrapper>
    );
};

export default BankUcet;
